import { createEnrichedDataHook } from '@client/hooks/useBaseEnrichedData';
import { ProductBulkInitializeService } from '../services/bulkInitializeService';
import {
  PRODUCT_FIELD_TO_API,
  PRODUCT_API_TO_ENRICHED,
  PRODUCT_FIELD_TO_ENRICHED,
  PRODUCT_INITIAL_ENRICHED,
} from '@client/config/filterFieldMappings';

/**
 * Enriched data hook for Commercial Product search
 * Handles cold start by bulk fetching labels for URL state restoration
 */
export const useProductEnrichedData = createEnrichedDataHook({
  fieldToApiMapping: PRODUCT_FIELD_TO_API,
  apiToEnrichedMapping: PRODUCT_API_TO_ENRICHED,
  fieldToEnrichedMapping: PRODUCT_FIELD_TO_ENRICHED,
  bulkInitialize: (ids) => ProductBulkInitializeService.bulkInitialize(ids),
  initialEnrichedData: PRODUCT_INITIAL_ENRICHED,
  hookName: 'useProductEnrichedData',
});

export default useProductEnrichedData;
